var _style, _text, _style2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleLoginFloatinTextBangers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 181 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      display: "block",
      shapeRendering: "auto",
      background: "transparent"
    },
    width: 181,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n  .ld-text text {\r\n    text-anchor: middle;\r\n    dominant-baseline: middle;\r\n    font-size: 80px;\r\n    opacity: 0;\r\n    user-select: none;\r\n    pointer-events: none;\r\n  }\r\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "90.5px 50px",
      transform: "scale(1)"
    },
    className: "ld-text"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.5,50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0000) translate(0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-68.56px 0.03px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 15, 0, 1)",
      animation: "1s linear 0s 1 normal forwards running animate-ik33kh0q7ms",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.96 58.93L0.96 58.93Q1.84 52.61 2.84 46.21Q3.84 39.81 4.92 33.85Q6 27.89 6.96 23.09L6.96 23.09Q8 17.89 9.04 12.53Q10.08 7.17 11.20 1.73L11.20 1.73L25.20-0.11L21.04 17.97Q19.92 22.69 18.76 28.09Q17.60 33.49 16.64 38.53Q15.68 43.57 15.12 47.49L15.12 47.49Q17.12 47.33 19.40 47.29Q21.68 47.25 23.44 47.25L23.44 47.25Q23.52 49.09 23.76 51.13Q24 53.17 24.28 54.65Q24.56 56.13 24.56 56.29L24.56 56.29Q24.24 56.29 23.96 56.29Q23.68 56.29 23.36 56.21L23.36 56.21L22.08 56.21Q18.96 56.21 15.16 56.49Q11.36 56.77 7.64 57.37Q3.92 57.97 0.96 58.93",
    style: {
      fill: "rgb(96, 84, 151)"
    },
    transform: "translate(-81.640,-29.384)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "-33.84px -0.37px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 15, 0, 1)",
      animation: "1s linear 0.132s 1 normal forwards running animate-ik33kh0q7ms",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.64 59.09L38.64 59.09Q33.36 59.09 30 55.01Q26.64 50.93 26.64 42.69L26.64 42.69Q26.64 38.13 27.76 33.09Q28.88 28.05 30.88 23.17Q32.88 18.29 35.52 14.13L35.52 14.13Q39.76 7.41 45.28 3.17Q50.80-1.07 56.88-1.07L56.88-1.07Q61.68-1.07 64.28 1.37Q66.88 3.81 67.92 7.61Q68.96 11.41 68.96 15.49L68.96 15.49Q68.96 25.01 66.04 33.21Q63.12 41.41 58.48 47.09L58.48 47.09Q53.84 52.93 48.60 56.01Q43.36 59.09 38.64 59.09 zM42.96 45.89L42.96 45.89Q46.56 45.89 49.32 43.49Q52.08 41.09 54 37.37Q55.92 33.65 56.88 29.57Q57.84 25.49 57.84 22.21L57.84 22.21Q57.84 20.93 57.60 19.45Q57.36 17.97 56.56 16.85Q55.76 15.73 54.08 15.73L54.08 15.73Q50.40 15.73 47.44 18.41Q44.48 21.09 42.48 25.17L42.48 25.17Q40.48 29.33 39.52 33.33Q38.56 37.33 38.56 40.61L38.56 40.61Q38.56 42.29 39.76 44.09Q40.96 45.89 42.96 45.89",
    style: {
      fill: "rgb(96, 84, 151)"
    },
    transform: "translate(-81.640,-29.384)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "6.36px 0.43px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 15, 0, 1)",
      animation: "1s linear 0.264s 1 normal forwards running animate-ik33kh0q7ms",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.44 60.69L81.44 60.69Q78.48 60.69 75.80 59.41Q73.12 58.13 71.20 55.49L71.20 55.49Q69.20 52.93 68.08 49.01Q66.96 45.09 66.96 39.81L66.96 39.81Q66.96 29.49 69.92 21.81Q72.88 14.13 77.44 9.01L77.44 9.01Q81.92 3.89 87.08 1.41Q92.24-1.07 96.72-1.07L96.72-1.07Q101.04-1.07 103.76 0.81Q106.48 2.69 107.76 5.81Q109.04 8.93 109.04 12.77L109.04 12.77L98.08 14.85Q97.36 11.65 96.16 10.29Q94.96 8.93 93.44 8.93L93.44 8.93Q91.68 8.93 89.80 10.85Q87.92 12.77 86.12 16.01Q84.32 19.25 82.88 23.25Q81.44 27.25 80.52 31.49Q79.60 35.73 79.44 39.49L79.44 39.49Q79.44 44.45 80.92 46.57Q82.40 48.69 84.72 48.69L84.72 48.69Q86.96 48.69 89.16 47.25Q91.36 45.81 92.84 43.37Q94.32 40.93 94.40 37.89L94.40 37.89L85.84 39.17L87.36 31.25L94.72 30.29Q97.76 29.89 101.16 29.33Q104.56 28.77 107.12 28.29L107.12 28.29Q106.56 36.45 103.96 42.57Q101.36 48.69 97.52 52.69Q93.68 56.69 89.48 58.69Q85.28 60.69 81.44 60.69",
    style: {
      fill: "rgb(96, 84, 151)"
    },
    transform: "translate(-81.640,-29.384)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "33.48px 0.35px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 15, 0, 1)",
      animation: "1s linear 0.396s 1 normal forwards running animate-ik33kh0q7ms",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.92 58.69L103.92 58.69Q105.04 54.05 106.16 48.17Q107.28 42.29 108.40 35.97Q109.52 29.65 110.48 23.81L110.48 23.81Q111.36 18.69 112.20 13.41Q113.04 8.13 113.84 2.77L113.84 2.77L126.32 0.77L122.72 21.81Q121.52 29.25 120.60 35.17Q119.68 41.09 118.84 46.37Q118 51.65 117.12 57.17L117.12 57.17Q115.60 57.17 113.44 57.37Q111.28 57.57 109.12 57.85Q106.96 58.13 105.48 58.37Q104 58.61 103.92 58.69",
    style: {
      fill: "rgb(96, 84, 151)"
    },
    transform: "translate(-81.640,-29.384)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "path",
    style: {
      opacity: 0,
      transformOrigin: "60.52px -0.41px",
      transform: "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 15, 0, 1)",
      animation: "1s linear 0.528s 1 normal forwards running animate-ik33kh0q7ms",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.76 56.45L120.08 59.17Q122.48 47.65 124.64 36.85L124.64 36.85Q126.40 26.69 128.08 17.33Q129.76 7.97 130.48 0.13L130.48 0.13Q131.04 0.21 131.48 0.21Q131.92 0.21 132.24 0.21L132.24 0.21L133.92 0.21Q136 0.21 138.56 0.09Q141.12-0.03 143.28-0.11L143.28-0.11Q143.84 2.69 144.36 5.41Q144.88 8.13 145.28 10.69L145.28 10.69Q145.68 12.93 146.16 15.29Q146.64 17.65 147.12 20.05L147.12 20.05Q147.52 22.45 147.96 24.49Q148.40 26.53 148.72 28.21L148.72 28.21Q149.68 23.49 150.52 18.93Q151.36 14.37 152.16 10.69L152.16 10.69L154.48-0.03L164.24-1.23Q162.88 4.85 161.68 10.69Q160.48 16.53 159.44 21.97L159.44 21.97Q157.44 31.73 155.92 40.37Q154.40 49.01 153.60 55.41L153.60 55.41Q154.48 55.41 153.32 55.61Q152.16 55.81 149.92 56.17Q147.68 56.53 145.12 57.09Q142.56 57.65 140.56 58.45L140.56 58.45Q140.32 55.25 140.08 52.21Q139.84 49.17 139.52 46.29L139.52 46.29Q139.04 41.17 138.40 36.13Q137.76 31.09 137.12 28.13L137.12 28.13Q136.56 31.65 135.76 36.17Q134.96 40.69 134 45.25L134 45.25L131.76 56.45",
    style: {
      fill: "rgb(96, 84, 151)"
    },
    transform: "translate(-81.640,-29.384)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    dy: "0.35em",
    fill: "#605497",
    fontFamily: "Bangers",
    fontSize: 80
  }, "login")))), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@keyframes animate-ik33kh0q7ms { 0.00% {transform: translate(0.00px,15.00px) rotate(0.00deg) scale(1.00, 1.00) skew(0deg, 0.00deg) ;opacity: 0.00;}2.00% {animation-timing-function: cubic-bezier(0.65,0.72,0.32,0.38);transform: translate(0.00px,9.36px) rotate(0.00deg) ;opacity: 0.10;}6.00% {transform: translate(0.00px,7.58px) rotate(0.00deg) ;opacity: 0.30;}8.00% {animation-timing-function: cubic-bezier(0.66,0.69,0.33,0.35);transform: translate(0.00px,7.02px) rotate(0.00deg) ;opacity: 0.40;}14.00% {transform: translate(0.00px,5.82px) rotate(0.00deg) ;opacity: 0.70;}16.00% {animation-timing-function: cubic-bezier(0.66,0.68,0.33,0.34);transform: translate(0.00px,5.51px) rotate(0.00deg) ;opacity: 0.80;}20.00% {animation-timing-function: cubic-bezier(0.22,0.43,0.59,0.75);transform: translate(0.00px,4.97px) rotate(0.00deg) ;opacity: 1.00;}100.00% {animation-timing-function: cubic-bezier(0.22,0.43,0.59,0.75);transform: translate(0.00px,0.00px) rotate(0.00deg) ;opacity: 1.00;} }")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleLoginFloatinTextBangers);
export default __webpack_public_path__ + "static/media/purple-login-floatin-text-bangers.982b0fa346ae0a085dd75eaca9db98cf.svg";
export { ForwardRef as ReactComponent };